<template>
  <div class="appintro">
    <h2>Bubblemaps V2</h2>
    <h4>
      Track real-time token distribution, uncover wallet clusters, and explore
      token history across chains - visually and instantly.
    </h4>
    <Button
      raised
      class="appintro__button"
      link="https://v2.bubblemaps.io"
      target="_blank"
    >
      Launch App
    </Button>
    <Button outlined class="appintro__button" route="/v2" target="_blank">
      Read More
    </Button>
    <LottieDemo />
    <div class="appintro__chains">
      <img src="@/assets/logos/chains/eth.png" alt="Ethereum" />
      <img src="@/assets/logos/chains/sol.png" alt="Solana" />
      <img src="@/assets/logos/chains/bnb.png" alt="BNB Chain" />
      <img src="@/assets/logos/chains/avax.png" alt="Avalanche" />
      <img src="@/assets/logos/chains/pol.png" alt="Polygon" />
      <span style="white-space: nowrap">
        <img src="@/assets/logos/chains/base.jpg" alt="Base" />
        <img src="@/assets/logos/chains/arb.png" alt="Arbitrum" />
        <img src="@/assets/logos/chains/hype.png" alt="HyperEVM" />
        <img src="@/assets/logos/chains/ton.png" alt="TON" />
      </span>
      <span style="white-space: nowrap">
        <img src="@/assets/logos/chains/s.png" alt="Sonic" />
        <img src="@/assets/logos/chains/trx.png" alt="Tron" />
        <img src="@/assets/logos/chains/mon.png" alt="Monad" />
        <img src="@/assets/logos/chains/aptos.png" alt="Aptos" />
        <img src="@/assets/logos/chains/robinhood.png" alt="Robinhood" />
        <img src="@/assets/logos/chains/arc.jpg" alt="Arc" />
      </span>
    </div>
    <Button
      outlined
      class="appintro__button"
      link="https://opv2f2kymb4.typeform.com/to/BrAitYn3"
      target="_blank"
    >
      Add Your Chain
    </Button>
  </div>
</template>

<script>
import "@lottiefiles/lottie-player";
import Button from "@/components/atoms/material/Button.vue";
import LottieDemo from "@/components/molecules/LottieDemo.vue";

export default {
  name: "AppIntro",
  components: { Button, LottieDemo },
};
</script>

<style scoped lang="scss">
@import "src/assets/variables";

.appintro {
  text-align: center;

  .appintro__button {
    margin: 20px 5px 0 5px;
  }

  .appintro__chains {
    img {
      height: 40px;
      width: 40px;
      margin: 5px;
      border-radius: 100px;
    }
  }
}
</style>
